import Vue from "vue";
function arDirective(el: any, options: any) {
  if (window._i18n_.isArLanguage) {
    el.classList.add("ar-transform");
    if (options.modifiers.rtl) {
      el.classList.add("ar-transform-rtl");
    }
    if (options.modifiers.tl) {
      el.classList.add("ar-transform-tl");
    }
    if (options.modifiers.tc) {
      el.classList.add("ar-transform-tc");
    }
    if (options.modifiers.tr) {
      el.classList.add("ar-transform-tr");
    }
  }
}

Vue.directive("ar", {
  // 指令的定义
  bind: function (el: any, options: any) {
    arDirective(el, options);
  },
  update(el, options) {
    arDirective(el, options);
  },
});

function rtlDirective(el: any, options: any) {
  if (window._i18n_.isArLanguage) {
    el.style.direction = "rtl";
  }
}

Vue.directive("rtl", {
  // 指令的定义
  bind: function (el: any, options: any) {
    rtlDirective(el, options);
  },
  update(el, options) {
    rtlDirective(el, options);
  },
});
